import { useMemo } from 'react';

import { gameHasStarted } from '@pkg/hooks';

import { useFantasyLineupStore, useFantasyMetadataStore } from '@app/store/zustand';

export function useFantasyLineupMetadata() {
    const { lineupListItems: listItems } = useFantasyLineupStore();
    const { currentGameWishlist, currentGame } = useFantasyMetadataStore();
    const gameStarted = gameHasStarted(currentGame?.submission_starts_at);
    const didNotSubmit = !currentGameWishlist && gameStarted;
    const maxQuantity = Number(currentGame?.max_assets || 0);

    const editable = !currentGameWishlist;
    const minimumCollectionCount = Number(currentGame?.min_collection_count || 3);
    const totalTokens = useMemo(() => {
        return listItems?.reduce((acc, item) => acc + (item?.quantity || 0), 0) || 0;
    }, [listItems]);

    return { maxQuantity, totalTokens, editable, minimumCollectionCount, didNotSubmit };
}
